module.exports = __webpack_public_path__ + "img/loginLogo.ffa6e2b4.png";